<template>
  <div
    class="pt-5 page-header align-items-start min-vh-50 pb-11 row"    
  >
    <span class="bg-gradient-dark opacity-6"></span>
    <div class="container">
      <div class="row justify-content-center">
        <div class="mx-auto text-center col-lg-5">
          <img src="../assets/img/ToMate-black.png" alt="main_logo" style=" z-index: 1099; height: 220px; margin: -50px 0px 0px 0px;"/>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row" style="justify-content: center;">
        <div class="mb-4 col-xl-4 col-lg-6 col-md-12 d-flex flex-column"> 
          <div class="container" style="width: fit-content;">
            <div class="card z-index-0" style="min-width: 349px">
              <div class="pb-0 card-header text-center">
                <img src="../assets/img/cross.png" height="45" width="45"/>
                  <h3 class="font-weight-bolder" style="color: #FF3131">
                    Payment error
                  </h3>   
              </div>
              <div class="card-body text-center">
                  <p class="mb-0">We could not complete de payment process, please check your payment method and try again.</p>
              </div>

              <div class="card-footer text-center">
                  <soft-button
                    @click="goToPacks()"
                    class="mb-2"
                    style="background-color: #FF3131;"
                    full-width
                    >Go for it
                  </soft-button>
                </div>
            </div>
          </div>
        </div>
        <div class="mb-4 col-xl-4 col-lg-6 col-md-12 d-flex flex-column"> 
          <div class="container" style="width: fit-content;">
              <img height="400" style="opacity: 0.6;" src="../assets/img/Computer-troubleshooting-rafiki.png" />
          </div>
        </div>
      </div>
    </div>
        
  </div>
  
  <app-footer />
</template>

<script>
import AppFooter from "@/examples/PageLayout/Footer.vue";
import SoftButton from "@/components/SoftButton.vue";
import { mapMutations } from "vuex";
import HTFetch from "../llamadas/HTFetch"
import K from "../llamadas/K"
import router from '../router/index'

export default {
  name: "SuccessPayment",
  components: {
    AppFooter,
    SoftButton
  },

  created() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();

    if (this.$gtm.enabled()) {
      window.dataLayer?.push({
        event: "fail-payment",
        user_id: localStorage.userId
      });
    }
  },

  beforeUnmount() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
  },

  data() {
    return {
      password: "",
      llamada: new HTFetch(),
      K: new K(),
      wrongCreds: false,
      new_password1: "",
      new_password2: ""
    }
  },

  methods: {
    ...mapMutations(["toggleEveryDisplay", "toggleHideConfig"]),

    goToPacks() {

      router.push({name: "Packs"})
    },
  },
};
</script>
<style scoped>
</style>
